import { useSelector, useDispatch } from 'react-redux'
import { Divider } from 'antd'

import styles from './index.module.css'
import SideBarNewChatButton from '../SideBarNewChatButton'
import SideBarChatHistoryList from '../SideBarChatHistoryList'
import SideMyStone from '../SideMyStone'
import SideMyStoneMall from '../SideMyStoneMall'
import SideMyStoneBackpack from '../SideMyStoneBackpack'


const ChatCount = () => {
    let chat_count_data = useSelector(state => state.get('home').get('chat_count_data')).toJS()

    return (
        <div className={styles.count_container}>
            <span className={styles.count_text}>今日对话次数</span>
            <span className={styles.count_text}>{chat_count_data.current_count} / {chat_count_data.max_count}</span>
        </div>
    )
}

const SideBarChatBox = () => {
    return (
        <div className={styles.container}>
            <div className={styles.new_chat_box}>
                <SideBarNewChatButton />
            </div>

            <div className={styles.progress_bar}>
                <SideMyStone />
            </div>

            <div className={styles.progress_bar}>
                <SideMyStoneMall />
            </div>

            <div className={styles.progress_bar}>
                <SideMyStoneBackpack />
            </div>

            <div className={styles.progress_bar}>
                <ChatCount />
            </div>

            {/* <div className={styles.divider_box}>
                <Divider style={{margin: "5px 0 20px 0", backgroundColor: "rgba(203, 209, 216, 0.5)"}} />
            </div> */}

            <div className={styles.chat_history_box}>
                <SideBarChatHistoryList />
            </div>
        </div>
    )
}

export default SideBarChatBox